import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PersonaQueryVariables = Types.Exact<{
  filters: Types.GetResourceByIdFilter;
}>;


export type PersonaQuery = { content?: { id: string, name: string, status: Types.ResourceStatusEnum, approvalStatus?: Types.ContentApprovalStatusEnum | null, knowledgeAssetSubTypeVariant?: Types.KnowledgeAssetSubTypeVariantEnum | null, industries?: Array<Types.KnowledgeAssetIndustryEnum> | null, userSurveyAttemptConfig?: Array<{ attemptId: string, userSurveyId: string }> | null, cover?: { url?: string | null } | null } | {} | null };


export const PersonaDocument = /*#__PURE__*/ gql`
    query persona($filters: GetResourceByIdFilter!) {
  content(filters: $filters) {
    ... on KnowledgeAssetContentType {
      id
      userSurveyAttemptConfig {
        attemptId
        userSurveyId
      }
      cover {
        url
      }
      name
      status
      approvalStatus
      knowledgeAssetSubTypeVariant
      industries
    }
  }
}
    `;

export function usePersonaQuery(options: Omit<Urql.UseQueryArgs<PersonaQueryVariables>, 'query'>) {
  return Urql.useQuery<PersonaQuery, PersonaQueryVariables>({ query: PersonaDocument, ...options });
};